import { z } from "zod";

/// Mirrors shore `MyTeamResponseDto` (T3 / FE-SEC6).
///
/// `ownMembershipId` is null when the caller has no live membership, which is
/// the "you have no team yet" case. `members` is the whole active reporting
/// line with the caller excluded: exactly the pool create-time enforcement
/// accepts for a `memberships` audience, so the picker cannot offer an id the
/// shore will reject.
export const myTeamAudienceSchema = z
  .object({
    ownMembershipId: z.string().nullable(),
    threshold: z.number().int(),
    directCount: z.number().int(),
    totalCount: z.number().int(),
    members: z.array(z.object({ membershipId: z.string(), displayName: z.string() })),
  })
  .strict();
export type MyTeamAudience = z.infer<typeof myTeamAudienceSchema>;
